import React, { Component } from 'react';
import { Slider } from 'antd';
import constants from '../../constants/appConstants';

const marks = {
  0.0: { label: <strong>0.0</strong> },
  1.0: { label: '1.0' },
  2.0: { label: '2.0' },
  3.0: { label: '3.0' },
  4.0: { label: '4.0' },
  5.0: { label: '5.0' },
  6.0: { label: '6.0' },
  7.0: { label: '7.0' },
  8.0: { label: '8.0' },
  9.0: { label: '9.0' },
  10.0: { label: <strong>10.0</strong> },
};

class FilterZMax extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // NOTE: Slider component has a strange quirk whereby it would disappear as you close the modal
    // you could fix this bug, but you'd have and ever more frustrating bug of a defaultValue
    // that does not change as you edit a different filter with different range
    const defaultVal = 0;

    return (
      <div className='filter-component reverse-color'>
        <strong>Z-Max Range: </strong>
        {this.props.visible && (
          <Slider
            range={false}
            defaultValue={this.props.range}
            step={0.1}
            marks={marks}
            min={0.0}
            max={10.0}
            onAfterChange={this.props.onAfterChange}
          />
        )}
        {!this.props.visible && (
          <Slider
            range={false}
            defaultValue={defaultVal}
            step={null}
            marks={marks}
            min={0.0}
            max={10.0}
          />
        )}
      </div>
    );
  }
}

export default FilterZMax;



// WEBPACK FOOTER //
// ./src/components/prospectIdentification/FilterZMax.js